import React from 'react'

function AdminProfile() {
    return (
        <div>
            sss
        </div>
    )
}

export default AdminProfile